import React from 'react';
import { Box, Heading, RawButton, RoundDoneIcon, Text } from '@common-fe/common-fe';

import theme from '@/styles/theme';

interface Props {
  title?: string;
  resendButtonTitle?: React.ReactNode;
  subTitle?: React.ReactNode;
  footerText?: string;
  disableResend?: boolean;
  onResend?: () => void;
}

const VerificationBackground: React.FC<Props> = ({
  title,
  resendButtonTitle,
  subTitle,
  footerText,
  disableResend,
  onResend,
}) => {
  return (
    <Box
      margin="auto"
      pad="spacing48"
      round="container1Round"
      align="center"
      direction="column"
      style={{ zIndex: 99 }}
    >
      <Box direction="column" align="center">
        <RoundDoneIcon color={theme.colors.navigationAccent2} />
        <Heading
          data-testid="verification-header"
          level={1}
          color="textOnColor"
          size="regular"
          margin={{ vertical: 'spacing12' }}
        >
          {title || 'Verification link sent!'}
        </Heading>
        <Box>{subTitle}</Box>
        <Box align="center" margin={{ top: 'spacing12' }}>
          <Text size="large" color="textOnColor" style={{ lineHeight: 1.2 }}>
            Didn’t get an email?{' '}
            <RawButton
              onClick={disableResend ? () => {} : onResend}
              data-testid="send-again"
              style={
                disableResend
                  ? {
                      cursor: 'not-allowed',
                      opacity: 0.65,
                    }
                  : {}
              }
            >
              <Text size="large" color="navigationAccent2">
                {resendButtonTitle}
              </Text>
            </RawButton>
          </Text>
        </Box>
        <Box margin={{ top: 'spacing24' }}>
          <Text size="small" color="textOnColor" style={{ opacity: 0.4 }}>
            {footerText || 'If you received a confirmation email, you can close this page.'}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default VerificationBackground;
